$(() => {
  //href为空的链接 不能点击跳转
  $('body').on('click', 'a', function (event) {
    const href = $(this).attr('href');
    if (!href) {
      event.preventDefault();
    }
  });
});
